var _g, _path, _path2, _circle, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_518_2739)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.3552,
    cy: 19.7419,
    rx: 19.3552,
    ry: 19.3548,
    fill: "url(#paint0_radial_518_2739)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7931 25.2626C16.1708 26.9944 17.1313 28.5442 18.5142 29.653C19.8971 30.7618 21.6187 31.3625 23.3912 31.3547C25.1637 31.3469 26.8799 30.7312 28.2531 29.6103C29.6262 28.4894 30.5732 26.9313 30.9357 25.1963L29.5846 24.914C29.2867 26.3397 28.5086 27.62 27.3802 28.5411C26.2519 29.4621 24.8417 29.9681 23.3852 29.9745C21.9286 29.9808 20.514 29.4872 19.3777 28.5761C18.2413 27.665 17.452 26.3915 17.1416 24.9685L15.7931 25.2626Z",
    fill: "#39383D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6152 24.2581H31.0994L30.8721 25.5484H15.8547L15.6152 24.9033V24.2581Z",
    fill: "#39383D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.6777,
    cy: 15.9355,
    r: 2,
    fill: "#39383D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.3887,
    cy: 15.9355,
    r: 2,
    fill: "#39383D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_518_2739",
    x: 0,
    y: 0.387085,
    width: 46.7109,
    height: 46.7097,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_518_2739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_518_2739",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_518_2739",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.1615 10.8387) rotate(77.6373) scale(28.9289 28.9293)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableHappy);
export default __webpack_public_path__ + "static/media/DisableHappy.6c3bded0d338a1dad8cf10e82e156865.svg";
export { ForwardRef as ReactComponent };